let clients = [
    {
        link: '',
        img: require("../img/clients/amazon.png")
    },
    {
        link: '',
        img: require("../img/clients/autodesk.png" )
    },
    {
        link: '',
        img: require("../img/clients/bestbuy.png" )
    },
    {
        link: '',
        img: require("../img/clients/lyft.png" )
    },
    {
        link: '',
    img: require("../img/clients/nordstrom.png" )
    },
    {
        link: '',
        img: require("../img/clients/riot.png" )
    },
    {
        link: '',
        img: require("../img/clients/salesforce.png" )
    },
    {
        link: '',
        img: require("../img/clients/SCE.png" )
    },
    {
        link: '',
        img: require("../img/clients/stripe.png" )
    },
    {
        link: '',
        img: require("../img/clients/ted.png" )
    },
    {
        link: '',
        img: require("../img/clients/yerba.webp" )
    },
    {
        link: '',
        img: require("../img/clients/airbus.png" )
    },
    {
        link: '',
        img: require("../img/clients/delta.png" )
    },
    {
        link: '',
        img: require("../img/clients/ikea.png" )
    },
    {
        link: '',
        img: require("../img/clients/bmgf.png" )
    },
    {
        link: '',
        img: require("../img/clients/girlrising.png" )
    },
    {
        link: 'https://www.imperfectproduce.com/',
        img: require("../img/clients/imperfect.png" )
    },
    {
        link: '',
        img: require("../img/clients/kaiser.png" )
    },
    {
        link: '',
        img: require("../img/clients/malala.png" )
    },
    {
        link: '',
        img: require("../img/clients/patagonia.png" )
    },
    {
        link: '',
        img: require("../img/clients/pattern.png" )
    },
    {
        link: '',
        img: require("../img/clients/wb.png" )
    },
    {
        link: '',
        img: require("../img/clients/lls.png" )
    },
    {
        link: '',
        img: require("../img/clients/stryker.png" )
    },
    {
        link: '',
        img: require("../img/clients/luna.jpg" )
    },
    {
        link: '',
        img: require("../img/clients/parks.png" )
    },
    {
        link: '',
        img: require("../img/clients/heifer.png" )
    },
    {
        link: '',
        img: require("../img/clients/un.png" )
    },
];

export default clients; 